import { render, staticRenderFns } from "./content-group.vue?vue&type=template&id=1a8c0228&scoped=true"
import script from "./content-group.vue?vue&type=script&lang=js"
export * from "./content-group.vue?vue&type=script&lang=js"
import style0 from "./content-group.vue?vue&type=style&index=0&id=1a8c0228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8c0228",
  null
  
)

export default component.exports